
import React from 'react';
import './Choosingpallets.css';

import img1 from '../../../imgs/Choosingpallet1.webp';
import img2 from '../../../imgs/Choosingpallet2.webp';
import img3 from '../../../imgs/Choosingpallet3.webp';

const blogs = [
  {
    tag: '#Knowledge',
    title: 'How To Choosing The Right Plastic Pallet Injection Molding Machine?',
    date: 'Dec. 13, 2022 | Read Blog',
    image: img1,
  },
  {
    tag: '#Knowledge',
    title: 'What Are The Advantages of Plastic Pallets?',
    date: 'Dec. 21, 2022 | Read Blog',
    image: img2,
  },
  {
    tag: '#Knowledge',
    title: 'Common Types of Plastic Pallets',
    date: 'Dec. 9, 2022 | Read Blog',
    image: img3,
  },
];

const Choosingpallets = () => {
  return (
    <div className="choosingpallets-container">
      {blogs.map((blog, index) => (
        <div className="blog-card" key={index}>
          <img src={blog.image} alt={blog.title} />
          <div className="blog-content">
            <p className="blog-tag">{blog.tag}</p>
            <h3>{blog.title}</h3>
            <div className="blog-footer">
              <span>{blog.date}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Choosingpallets;
